var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "conditions" },
      [
        _c("table-columns-sidesheet", {
          ref: "tableColumnsModal",
          attrs: { columns: _vm.columns },
          on: { apply: _vm.saveConditionColumns },
        }),
        _c(
          "draggable",
          {
            staticClass: "item-container",
            attrs: {
              tag: "div",
              "ghost-class": "sortable__ghost",
              handle: ".handle",
              "force-fallback": true,
            },
            model: {
              value: _vm.localValue,
              callback: function ($$v) {
                _vm.localValue = $$v
              },
              expression: "localValue",
            },
          },
          _vm._l(_vm.localValue, function (condition, i) {
            return _c(
              "div",
              { key: condition.unique, staticClass: "condition" },
              [
                _c("div", { staticClass: "condition__border" }, [
                  _c("div", { staticClass: "condition__wrapper" }, [
                    _vm.localValue.length > 1
                      ? _c(
                          "div",
                          { staticClass: "condition__move handle" },
                          [
                            _c("c-button-2", {
                              attrs: {
                                size: "iconic",
                                icon: "arrows-constructor",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "condition__content" },
                      [
                        _c(
                          "div",
                          { staticClass: "condition__title" },
                          [
                            _c("svg-icon", {
                              staticClass: "condition__toggle",
                              class: {
                                open: condition.opened,
                              },
                              attrs: {
                                name: "chevron-top-circled",
                                size: 24,
                                color: "primary",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.$set(
                                    condition,
                                    "opened",
                                    !condition.opened
                                  )
                                },
                              },
                            }),
                            _vm._v(" Условие " + _vm._s(i + 1) + " "),
                            _c("c-button-2", {
                              staticClass: "condition__remove desktop",
                              attrs: {
                                size: "iconic",
                                icon: { icon: "trash", color: "secondary" },
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.removeCondition(condition)
                                },
                              },
                            }),
                            _c("c-button", {
                              staticClass: "condition__remove mobile",
                              attrs: {
                                label: "Удалить",
                                icon: { icon: "trash", color: "secondary" },
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.removeCondition(condition)
                                },
                              },
                            }),
                            _vm.localValue.length > 1
                              ? _c("c-button-2", {
                                  staticClass: "move handle",
                                  attrs: {
                                    size: "iconic",
                                    icon: "arrows-constructor",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c("transition", { attrs: { name: "slide" } }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: condition.opened,
                                  expression: "condition.opened",
                                },
                              ],
                              staticClass: "condition__data",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "condition__selects" },
                                [
                                  _c("c-input", {
                                    staticClass: "condition__roles",
                                    attrs: {
                                      type: "select",
                                      label: "Роли",
                                      items: _vm.roles,
                                      multiple: true,
                                      searchable: true,
                                      placeholder: "Выбрать роль",
                                    },
                                    model: {
                                      value: condition.roles,
                                      callback: function ($$v) {
                                        _vm.$set(condition, "roles", $$v)
                                      },
                                      expression: "condition.roles",
                                    },
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "condition__selects-divider",
                                    },
                                    [_vm._v("или")]
                                  ),
                                  _c("c-input", {
                                    staticClass: "condition__posts",
                                    attrs: {
                                      type: "select",
                                      label: "Должности",
                                      items: _vm.posts,
                                      multiple: true,
                                      searchable: true,
                                      placeholder: "Выбрать должность",
                                    },
                                    model: {
                                      value: condition.posts,
                                      callback: function ($$v) {
                                        _vm.$set(condition, "posts", $$v)
                                      },
                                      expression: "condition.posts",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "condition__columns" },
                                [
                                  _c(
                                    "h-button",
                                    {
                                      attrs: {
                                        disabled:
                                          !condition.posts.length &&
                                          !condition.roles.length,
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setConditionColumns(
                                            condition,
                                            i
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(" Настроить столбцы "),
                                      _c(
                                        "span",
                                        { staticClass: "columns-count" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getColumnsLength(
                                                condition.columns
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }